import { Controller } from "@hotwired/stimulus"
import { createIcons, Trash2 } from "lucide"
export default class extends Controller {
  static targets = ["target", "template"]

  add(e) {
    e.preventDefault()
    // Mengganti placeholder 'NEW_RECORD' dengan timestamp unik agar Rails mengenali sebagai record baru
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.targetTarget.insertAdjacentHTML('beforeend', content)
    
    createIcons({
      icons: {
        Trash2
      }
    })
  }

  remove(e) {
    e.preventDefault()
    const wrapper = e.target.closest(".nested-form-wrapper")
    
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      // Untuk record yang sudah ada di DB, tandai dengan _destroy = 1
      wrapper.querySelector("input[name*='_destroy']").value = "1"
      wrapper.style.display = "none"
    }
  }
}